import { render, staticRenderFns } from "./cadnaturezasoperacoes.vue?vue&type=template&id=49051f38&"
import script from "./cadnaturezasoperacoes.vue?vue&type=script&lang=js&"
export * from "./cadnaturezasoperacoes.vue?vue&type=script&lang=js&"
import style0 from "./cadnaturezasoperacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports